module.exports = __webpack_public_path__ + "static/img/product－image－16.888d391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product－image－16.png
// module id = g/Br
// module chunks = 1